import type { RequestConfig } from '@umijs/max';
import { message as notifyMessage, notification } from 'antd';

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
    errorConfig: {
        errorHandler: (error: any, opts: any) => {
            if (opts?.skipErrorHandler) throw error;

            if (error.response) {
                if (error.response.data?.message) {
                    switch (error.response.data?.code) {
                        case 5000:
                            console.log(`Logging error message: ${error.response.data?.message}`);
                            notifyMessage.error(
                                '伺服器錯誤！ 請聯絡管理員：' + error.response.data?.message
                            );
                            break;
                        case 4000:
                            notifyMessage.warning(error.response.data?.message);
                            break;
                        case 2000:
                            notification.open({
                                description: error.response.data?.message,
                                message: error.response.data?.code,
                            });
                            break;
                        default:
                            notifyMessage.error(error.response.data?.message);
                    }
                }
            } else if (error.request) {
                notifyMessage.error('None response! Please retry.');
            } else {
                notifyMessage.error('Request error, please retry.');
            }
        },
    },
};
